import styled, { css } from "styled-components";

import {
  DividerWrapper,
  PlusBar,
  PlusButton,
} from "@FillInTableContainer/shared/styles/dividerPlusBar.style";

export const GroupShellDividerWrapper = styled(DividerWrapper)`
  left: 0.8rem;
  width: calc(100% - 1.6rem);

  ${({ isLastPosition }) =>
    isLastPosition &&
    css`
      top: calc(100% - 0.8rem);
    `}
`;

export const GroupShellDividerPlusBar = styled(PlusBar)`
  width: 100%;
`;

export const SubGroupShellPlusButton = styled(PlusButton)``;

export const TableRowDividerWrapper = styled(DividerWrapper)`
  left: 1.2rem;
  width: calc(100% - 3.6rem);
  height: 0.4rem;
  z-index: 10;

  ${({ isLastPosition }) =>
    isLastPosition &&
    css`
      top: calc(100% - 0.8rem);
    `}

  &:hover {
    .divider-plus-bar {
      height: 0.2rem;
      border-radius: var(--Border-Radius-circle, 99999.9rem);
      background: var(--Color-Bg-Interactive-Selected-Pressed, #a4dfff);
    }

    .divider-plus-button {
      left: -2.6rem;
      top: -8px;
      width: 1.6rem;
      height: 1.6rem;
      border: none !important;
      outline: none !important;

      background: var(--Color-Common-Bg-Interactive-Selected-Hovered, #efffff);
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.12);
      padding: 0.2rem;

      & > svg {
        display: block;
      }
      outline: none;
    }
  }

  &:active {
    .divider-plus-bar {
      height: 0.2rem;
      border-radius: var(--Border-Radius-circle, 99999.9rem);
      background: var(--Color-Bg-Interactive-Selected-Pressed, #76cffe);
    }

    .divider-plus-button {
      left: -2.6rem;
      top: -8px;
      width: 1.6rem;
      height: 1.6rem;
      border: none !important;
      outline: none !important;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.12);
      padding: 0.2rem;
      background: var(--Color-Bg-Interactive-Selected-Pressed, #76cffe);

      & > svg {
        display: block;
      }
      outline: none;
    }
  }
`;

export const TableRowPlusBar = styled(PlusBar)`
  height: 0.1rem;
  left: 1.8rem;
  transform: translate(0, 0);
  top: 2px;
  width: calc(100% - 3.8rem);
  opacity: 1;

  background: #e5e7eb;

  &:hover {
    height: 0.2rem;
  }
`;

export const TableRowShellPlusButton = styled(PlusButton)`
  position: absolute;
  transform: translate(0, 0);

  border: none;
  border-radius: var(--Border-Radius-circle, 99999.9rem);
  background: #cbd0d8;
  outline: none;
  opacity: 1;

  top: -1px;
  left: -1.8rem;
  width: 4px;
  height: 4px;
  padding: 0;
  box-shadow: none;
  & > svg {
    display: none;
  }

  &:hover {
    left: -2.2rem;
    top: -8px;
    width: 1.6rem;
    height: 1.6rem;
    border: none !important;
    outline: none !important;

    background: var(--Color-Common-Bg-Interactive-Selected-Hovered, #efffff);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.12);

    & > svg {
      display: block;
    }
  }

  &:active {
    left: -2.2rem;
    top: -8px;
    width: 1.6rem;
    height: 1.6rem;
    border: none !important;
    outline: none !important;

    border-radius: var(--Border-Radius-circle, 99999.9rem);
    background: var(--Color-Common-Bg-Interactive-Selected-Pressed, #a4dfff);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);

    & > svg {
      display: block;
    }
  }
`;
